package com.milta.core.localization.translations.nl

import com.milta.core.localization.SettingsStrings

internal val Settings = SettingsStrings(
    profileSectionTitle = "ORGANISATIEPROFIEL",
    profileNameLabel = "Naam van de organisatie",
    languageSectionTitle = "INTERFACETAAL",
    languageSearchPlaceholder = "Zoek een taal...",
    languageMoreAvailable = "%d andere talen beschikbaar",
    languageErrorGeneric = "Er is een fout opgetreden. Probeer het opnieuw.",
    subscriptionSectionTitle = "ABONNEMENT",
    subscriptionPlanLabel = "Formule",
    subscriptionBillingLabel = "Facturatie",
    subscriptionRenewalLabel = "Volgende verlenging",
    subscriptionBillingMonthly = "Maandelijks",
    subscriptionBillingAnnual = "Jaarlijks",
    subscriptionPlanOrganisationLabel = "Organisatie (Baas + team)",
    subscriptionPriceSuffix = "excl. btw / maand",
    subscriptionUnavailable = "Niet beschikbaar",
    deleteSectionTitle = "Organisatie verwijderen",
    deleteWarning = "Deze actie is permanent en onomkeerbaar.",
    deleteDescription = "Ritten en leveringsbewijzen worden verwijderd. Chauffeurs-/bezorgersaccounts worden losgekoppeld van de organisatie, maar nooit verwijderd.",
    deleteConfirmLabel = "Voer ter bevestiging de naam van de organisatie in",
    deleteButton = "Definitief verwijderen",
    deleteFinalDialogTitle = "Definitieve verwijdering bevestigen?",
    deleteFinalDialogMessage = "Deze actie kan niet ongedaan worden gemaakt. De organisatie, haar ritten en leveringsbewijzen worden definitief verwijderd.",
    deleteErrorGeneric = "Er is een fout opgetreden. Probeer het opnieuw.",
    legalSectionTitle = "JURIDISCHE VERMELDINGEN",
    legalTermsLabel = "Gebruiksvoorwaarden",
    legalPrivacyLabel = "Privacy & AVG",
)
